const vitoria = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 25/26 - Uniforme 1",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2025",
      "2025 vitória",
      "vitoria 2025",
      "2025 vitoria",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/25-26-01/vit0.jpg",
      "/images/brasil/serie-a/vitoria/25-26-01/vit1.jpg",
      "/images/brasil/serie-a/vitoria/25-26-01/vit2.jpg",
      "/images/brasil/serie-a/vitoria/25-26-01/vit3.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 25/26 - Uniforme 2",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2025",
      "2025 vitória",
      "vitoria 2025",
      "2025 vitoria",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/25-26-02/vit0.jpg",
      "/images/brasil/serie-a/vitoria/25-26-02/vit1.jpg",
      "/images/brasil/serie-a/vitoria/25-26-02/vit2.jpg",
      "/images/brasil/serie-a/vitoria/25-26-02/vit3.jpg",
      "/images/brasil/serie-a/vitoria/25-26-02/vit4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 25/26 - Uniforme 3",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2025",
      "2025 vitória",
      "vitoria 2025",
      "2025 vitoria",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/25-26-03/vit0.jpg",
      "/images/brasil/serie-a/vitoria/25-26-03/vit1.jpg",
      "/images/brasil/serie-a/vitoria/25-26-03/vit2.jpg",
      "/images/brasil/serie-a/vitoria/25-26-03/vit3.jpg",
      "/images/brasil/serie-a/vitoria/25-26-03/vit4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 25/26 - Uniforme de Goleiro (Bege)",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2025",
      "2025 vitória",
      "vitoria 2025",
      "2025 vitoria",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/25-26-05-gb/vit0.jpg",
      "/images/brasil/serie-a/vitoria/25-26-05-gb/vit1.jpg",
      "/images/brasil/serie-a/vitoria/25-26-05-gb/vit2.jpg",
      "/images/brasil/serie-a/vitoria/25-26-05-gb/vit3.jpg",
      "/images/brasil/serie-a/vitoria/25-26-05-gb/vit4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 24/25 - Uniforme Black",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2024",
      "2024 vitória",
      "vitoria 2024",
      "2024 vitoria",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vitoria/24-25-00-b/vit0.jpg",
      "/images/brasil/serie-a/vitoria/24-25-00-b/vit1.jpg",
      "/images/brasil/serie-a/vitoria/24-25-00-b/vit2.jpg",
      "/images/brasil/serie-a/vitoria/24-25-00-b/vit3.jpg",
      "/images/brasil/serie-a/vitoria/24-25-00-b/vit4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 24/25 - Uniforme Edição Especial Autismo",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2024",
      "2024 vitória",
      "vitoria 2024",
      "2024 vitoria",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vitoria/24-25-00-esa/vit0.jpg",
      "/images/brasil/serie-a/vitoria/24-25-00-esa/vit1.jpg",
      "/images/brasil/serie-a/vitoria/24-25-00-esa/vit2.jpg",
      "/images/brasil/serie-a/vitoria/24-25-00-esa/vit3.jpg",
      "/images/brasil/serie-a/vitoria/24-25-00-esa/vit4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 24/25 - Uniforme 1",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2024",
      "2024 vitória",
      "vitoria 2024",
      "2024 vitoria",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/24-25-01/vit0.png",
      "/images/brasil/serie-a/vitoria/24-25-01/vit1.png",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 24/25 - Uniforme 1 (Feminina)",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2024",
      "2024 vitória",
      "vitoria 2024",
      "2024 vitoria",
      "2024",
      "feminino",
      "vitória feminino",
      "feminino vitória",
      "vitoria feminino",
      "feminino vitoria",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/24-25-01-f/vit0.jpg",
      "/images/brasil/serie-a/vitoria/24-25-01-f/vit1.jpg",
      "/images/brasil/serie-a/vitoria/24-25-01-f/vit2.jpg",
      "/images/brasil/serie-a/vitoria/24-25-01-f/vit3.jpg",
      "/images/brasil/serie-a/vitoria/24-25-01-f/vit4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 23/24 - Uniforme 1",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2023",
      "2023 vitória",
      "vitoria 2023",
      "2023 vitoria",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/23-24-01/vit0.jpg",
      "/images/brasil/serie-a/vitoria/23-24-01/vit1.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 23/24 - Uniforme 2",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2023",
      "2023 vitória",
      "vitoria 2023",
      "2023 vitoria",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/23-24-02/vit0.jpg",
      "/images/brasil/serie-a/vitoria/23-24-02/vit1.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "vitoria",
    nome: "Vitória 23/24 - Uniforme (Roxo)",
    aliases: [
      "vitória",
      "vitória",
      "leão",
      "vitória 2023",
      "2023 vitória",
      "vitoria 2023",
      "2023 vitoria",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vitoria/23-24-05-r/vit0.jpg",
      "/images/brasil/serie-a/vitoria/23-24-05-r/vit1.jpg",
      "/images/brasil/serie-a/vitoria/23-24-05-r/vit2.jpg",
      "/images/brasil/serie-a/vitoria/23-24-05-r/vit3.jpg",
      "/images/brasil/serie-a/vitoria/23-24-05-r/vit4.jpg",
    ],
  },
];

export default vitoria;
